import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "plan-control" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "Contract_containerTitle" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "Contract_containerTitle_title" }, "Estado de mi plan")
], -1)
const _hoisted_3 = {
  key: 0,
  class: "estado-plan-contenedor"
}
const _hoisted_4 = { class: "documentos-plan" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Documentos disponibles", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Documentos transmitidos", -1)
const _hoisted_7 = { class: "tabla-planes" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", null, "Histórico de planes adquiridos", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Fecha de compra"),
    /*#__PURE__*/_createElementVNode("th", null, "Cantidad de documentos"),
    /*#__PURE__*/_createElementVNode("th", null, "Valor"),
    /*#__PURE__*/_createElementVNode("th", null, "CUS"),
    /*#__PURE__*/_createElementVNode("th", null, "Fecha de vencimiento")
  ])
], -1)
const _hoisted_10 = { class: "botones-historico" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.planInfo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createElementVNode("span", null, _toDisplayString(_ctx.normalizeNumberValidator(_ctx.planInfo.documentosDisponibles)), 1),
              _hoisted_5
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("span", null, _toDisplayString(_ctx.normalizeNumberValidator(_ctx.planInfo.documentosTransmitidos)), 1),
              _hoisted_6
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("table", null, [
              _hoisted_9,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.planInfo.planesComprados, (item) => {
                  return (_openBlock(), _createElementBlock("tr", { key: item }, [
                    _createElementVNode("td", null, _toDisplayString(_ctx.normalizeDateValidator(item.fechaInicio)), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.normalizeNumberValidator(item.cantidadDocumentos)), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.colombianCurrencyValidator(item.valor)), 1),
                    _createElementVNode("td", null, _toDisplayString(item.cus), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.normalizeDateValidator(item.fechaVencimiento)), 1)
                  ]))
                }), 128))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.planInfo)
      ? (_openBlock(), _createBlock(_component_Spinner, {
          key: 1,
          type: "modern"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("input", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.GoToHistorical())),
        type: "button",
        value: "Histórico",
        class: "Button_BColorDegraded Button_fontButtonError"
      }),
      _createElementVNode("input", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.GotoTransmision())),
        type: "button",
        value: "Regresar",
        class: "Button_BColorDegraded Button_fontButtonError"
      })
    ])
  ]))
}